import { Divider, Stack, Typography } from '@mui/material';
import { useCameraDetailContext } from '@pages/cameras/hook/CameraDetailsProvider';
import color from '@theme/Colors';
import { ReactNode, useEffect } from 'react';
import { transformScheduleData } from 'src/helpers';
import {
    BaseSectionCollapse,
    DataSectionHasSubItem,
    SectionHasSubItemHeader,
    SectionHasSubItemProps,
} from './BasicInfoMilesightCameraPTZ';
import useMileSightPTZ, { SectionsCollapsePTZ } from '@pages/cameras/hook/useMilesightPTZ';

type Props = {
    isOpenCollapse: { [key in SectionsCollapsePTZ]: boolean };
    handleToggleCollapse: (section: SectionsCollapsePTZ) => void;
};

export default function InitialPositionMilesightsCameraPTZ(props: Props) {
    const handleEdit = () => {
        console.log('Edit button clicked');
    };

    const { camera } = useCameraDetailContext();
    const { isOpenCollapse, handleToggleCollapse } = props;
    const PTZScheduledTask = camera?.PTZCamera?.PTZCameraConfig?.ScheduledTask;

    const dataSectionHasSubItems: DataSectionHasSubItem[] = transformScheduleData(
        PTZScheduledTask?.ScheduleList!,
        (dayName, schedule) => ({
            label: `${dayName}: `,
            value: schedule,
        })
    );

    const sectionHasSubItemProps: SectionHasSubItemProps = {
        title: 'Schedule settings',
        data: dataSectionHasSubItems,
    };

    const sectionsInitialPosition: SectionHasSubItemProps[] = [
        {
            title: sectionHasSubItemProps.title,
            data: sectionHasSubItemProps.data,
        },
        {
            title: 'Tasks interference settings',
            data: [
                {
                    label: 'Latency time:',
                    value: <Typography>{`${PTZScheduledTask?.RecoveryTime!}s (5-720s)`}</Typography>,
                },
            ],
        },
    ];

    return (
        <Stack id="initialPosition" border={'1px solid #E4E7EC'} borderRadius={2} flex={1}>
            {/* Basic Information */}
            <SectionHasSubItemHeader id="" title="Initial position" onEdit={handleEdit} />

            {/* Scheduled tasks */}
            <BaseSectionCollapse
                id="scheduledTasks"
                title="Scheduled tasks"
                isOpen={isOpenCollapse.scheduledTasks}
                onToggle={() => {
                    handleToggleCollapse(SectionsCollapsePTZ.ScheduledTasks);
                }}
                sections={sectionsInitialPosition}
            />
        </Stack>
    );
}
